const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaEspecie: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'DOENCA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'DOENCA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'DOENCA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

		case 'DOENCA_ESPECIE_SELECT_LISTADO':
			return {
				...state,
				listaEspecie: action.payload.data
			};

        default:
            return state;
    }
}
